import SelectorEngine from '../../../utils/dom/selector-engine';

const CLICK_EVENT = 'click';
const HIDDEN_CLASS = 'u-hidden';
const LOCKED_CLASS = 'is-locked';

class MyResourcesNoAccess {
	constructor() {
		this.isModalOpen = '';
		this.isAccredited = '';
		this.body = SelectorEngine.findOne('body');
		this.initEvents();
	}

	initEvents() {
		this._wrapper = document.querySelector('.lta-my-resources');
		if (this._wrapper !== null) {
			this.isAccredited = SelectorEngine.findOne('.lta-my-resources').getAttribute('data-isAccredited') || 'true';
			this.scrollable = SelectorEngine.findOne('.lta-my-resources').getAttribute('data-scrollable') || 'true';
			this.isModalShow = SelectorEngine.findOne('.lta-my-resources').getAttribute('data-enableModal') || 'false';

			if (this.isAccredited == 'false' && this.isModalShow == 'true') {
				const modalContainer = document.querySelector('.modal-overlay');
				modalContainer.classList.remove(HIDDEN_CLASS);

				if (this.scrollable == 'true') {
					modalContainer.addEventListener(CLICK_EVENT, () => {
						this.closeModal();
					});
				} else {
					this.body.classList.toggle('body-overflow-hidden');
				}
			}
		}
	}

	closeModal() {
		const modalContainer = document.querySelector('.modal-overlay');
		const noAccessMessageContainer = document.querySelector('.lta-my-resources-no-access-message');
		const myResoucesContent = document.querySelector('.lta-my-resources-content-access');
		const firstChild = myResoucesContent.firstElementChild;

		if (modalContainer && !modalContainer.classList.contains(HIDDEN_CLASS)) {
			modalContainer.classList.add(HIDDEN_CLASS);
			noAccessMessageContainer.classList.remove(HIDDEN_CLASS);
			firstChild.classList.add(LOCKED_CLASS);
		}
	}
}

const globalMyResourcesNoAccess = new MyResourcesNoAccess();
export default globalMyResourcesNoAccess;
